<template>
  <div>
    <section class="section">
      <div class="container">
        <h1 class="title">
          <img src="../assets/logo.png" :alt="this.$appName" />
        </h1>
        <h2 class="subtitle">
          <i>Powered by</i>
        </h2>
        <ul>
          <li>Vue.js</li>
          <li>Azure</li>
          <li>Netlify</li>
          <li>Buefy</li>
        </ul>
      </div>
    </section>
  </div>
</template>


<script>
export default {
  name: "About"
};
</script>